export const spaceDiceRules = [ {
    content1: 'SpaceDiceRule1',
    constent2: '',
    img: null,
}];














